import { breakpoints } from '@bnnvara/breakpoints';
import { Grid as BaseGrid } from '@bnnvara/grids';
import { Heading as BaseHeading } from '@bnnvara/typography';
import styled from 'styled-components';

export const Grid = styled(BaseGrid)`
  margin: 0;
  grid-gap: 0 24px !important;
`;

export const Link = styled.a`
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.primary.main};
  text-decoration: underline;
  display: inline;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ align }) => (align === 'center' ? 'center' : 'left ')};

  ${breakpoints.lg} {
    padding: 40px 120px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
    background-color: ${({ theme }) => theme.base.white};
  }
`;

export const Image = styled.img`
  margin: 16px 0;
`;

export const Heading = styled(BaseHeading)`
  margin-bottom: 16px;
`;

export const Paragraph = styled.p`
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 1.4;

  ${(props) =>
    props.flex &&
    `
    display: flex
  `}
`;

export const Error = styled.div`
  color: ${({ theme }) => theme.primary.main};
`;

export const PaymentStep = styled.div`
  padding: 24px 0;
`;

export const Icon = styled.svg`
  display: inline-block;
  flex: none;
  margin-right: 8px;
  width: 16px;
  height: 16px;
  fill: none;
  stroke-width: 4px;
  stroke: ${({ theme }) => theme.base.black};
  border: 2px solid ${({ theme }) => theme.secondary.light};
`;

export const Privacy = styled.em`
  font-size: 10px;
`;
